import React from 'react';
import DateInputProps from './DateInput.props';
import styles from './dateInput..module.scss';

const DateInput = (props: DateInputProps) => {
  const today = new Date();
  today.setUTCHours(0, 0, 0, 0);
  const currentDate = today.toISOString().split('T')[0];
  // const currentYear = today.getFullYear();
  const {
    dateChosen,
    onChange,
    minDate = currentDate,
    maxDate,
    className,
    disabled = false,
  } = props;

  const minDateObj = new Date(minDate);
  minDateObj.setUTCHours(0, 0, 0, 0);
  const effectiveMinDate = minDateObj > today ? minDate : currentDate;

  const maxDateObj = maxDate ? new Date(maxDate) : null;
  maxDateObj?.setUTCHours(0, 0, 0, 0);
  const effectiveMaxDate = maxDateObj
    ? maxDateObj < minDateObj
      ? effectiveMinDate
      : maxDateObj.toISOString().split('T')[0]
    : undefined;

  return (
    <div className={`${styles['date-input']} ${className}`}>
      <label htmlFor={props.id}>Move-in date</label>
      <input
        id={props.id}
        type="date"
        value={dateChosen}
        min={effectiveMinDate}
        max={effectiveMaxDate}
        onChange={(e) => onChange?.(e.target.value)}
        disabled={disabled}
      />
      {/* <p>Add MM/DD/YYYY format. For example, 02/21/{currentYear}.</p> */}
    </div>
  );
};

export default DateInput;
